/**
 * Determines the name to display in the top bar for a given user (next to the user's avatar).
 *
 * @param {Object} userObject - The object containing user data (either user.model or user directly)
 * @param {boolean} [enableUnifiedAccounts] - Represents the value of the ENABLE_UNIFIED_ACCOUNTS feature flag
 * TODO: Remove the above parameter when we remove this feature flag.
 *
 * @returns {string} The name to display in the top bar
 */
const getUserTopBarName = function(userObject, enableUnifiedAccounts) {
	if (enableUnifiedAccounts) {
		if (userObject.identifiesAsParent || userObject.identifiesAsEducator) {
			return userObject.firstName || userObject.email || "";
		} else {
			return (
				userObject.firstName ||
				userObject.globalUsername ||
				userObject.username ||
				userObject.email ||
				""
			);
		}
	} else {
		return (
			userObject.globalUsername ||
			userObject.username ||
			userObject.email ||
			userObject.displayName ||
			""
		);
	}
};

module.exports = {
	getUserTopBarName,
};
